export { default as Center } from './Center';
export type { CenterProps } from './types';
